import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Permission } from '@sda/interfaces/permission';

/**
 * SDK Class to interact with Firestore Permissions.
 */
export class Permissions extends SDK<Permission> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient);

    this.collection = this.fsh.Schema.Permissions;
  }
}
